module.exports = __webpack_public_path__ + "static/servicios-229693eac68c7832066cdb609c8ae7be.svg";